export default __webpack_public_path__ + "static/media/fs-project-4.5beb78af.png";